import styled from 'styled-components';

export const AppShell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
`;

export const Main = styled.main`
  flex: 1;
  width: 100%;
`;
